
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppSimpleTable } from '@/components';
import { usePicwordPetDetail } from '@/modules/picword/pet/model/detail';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.PET.DETAIL,
    components: { AppCard, AppButton, AppSimpleTable },
    setup() {
        const { model, fetch, actions } = usePicwordPetDetail();

        onMounted(async () => {
            await fetch();
        });

        return { model, actions, ROUTE_NAME_PICWORD };
    }
});
